import { authHeader, handleHttpResponse } from '_helpers';
import {SERVER_URL} from 'config';

function update(msgDataSourceId, data) {
    return fetch(`${SERVER_URL}/api/msgDataSources/kustomer/${msgDataSourceId}`,
        {
            method: 'PUT',
            headers: authHeader(),
            body: JSON.stringify(data)
        })
        .then(handleHttpResponse);
}

export const kustomerMsgDataSourceService = {
    update
};
